import { Divider } from "antd";
import {
  NotificationItem,
  NotificationWrapper,
  NotificationWrapperContent,
  NotificationMesaageWrapper,
  NotificationMessage,
  NotificationTime,
  NotificationBadge,
} from "../NotificationDrawer/NotificationDrawerStyled";
import NotificationStatusHeader from "./NotificationStatusHeader";
import PropTypes from 'prop-types';

const NotificationBlock = ({ item, onClick, isLast }) => {
  return (
    <NotificationItem onClick={() => onClick(item)}>
      <NotificationWrapper>
        <NotificationWrapperContent>
          <NotificationStatusHeader
            notification_type={item.notification_type}
            is_read={item.is_read}
          />
          {!item.is_read && <NotificationBadge data-testid="notification-badge"/>}
        </NotificationWrapperContent>

        <NotificationMesaageWrapper opacity={item.is_read.toString()}>
          <NotificationMessage>{item.message}</NotificationMessage>
          <NotificationTime>{item.time_ago}</NotificationTime>
        </NotificationMesaageWrapper>
      </NotificationWrapper>

      {!isLast && <Divider style={{ margin: "12px 0" }} />}
    </NotificationItem>
  );
};

NotificationBlock.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isLast: PropTypes.bool,
};

export default NotificationBlock;
